import { Company, Performer, Speciality } from "cw-backend";
import { Cid } from "../../../others/cid";
import { Insurance } from "./../../../accreditation/insurance";
import { Footer } from "./../../../register/organizational/footer";
import { Header } from "./../../../register/organizational/header";

export class DocumentModel {
    id: number;
    title: string;
    format: string;
    status: string;
    type: Type;
    static: boolean;
    document: null;
    active: boolean;
    company: Company;
    speciality: Speciality;
    insurance: Insurance;
    performer: Performer;
    header: Header;
    footer: Footer;
}

export class Document {
    id: number;
    title: string;
    format: string;
    type: number;
    documentModel: any;
    dateAt: any;
    document: null;
    documentBasic?: string = null;
    signed: string;
    companyCostCenter: any;
    company: any;
    insurance: any;
    performer: any;
    speciality: any;
    patient: any;
    header?: Header;
    footer?: Footer;
    professional: any;
    headerId: number;
    footerId: number;
    editing: boolean;
    isSigned?: boolean = false;
    deleted?: boolean = false;
    deletedAt?: any;
    deletedBy?: string;
}

export class Type {
    id: number;
    description: string;
    name: string;
}
export class DocumentDiagnosis {
    id: number;
    document: Document;
    cid: Cid;
    main: boolean = false;
}

export class Memed {
    data: {
        type: "usuarios";
        attributes: {
            external_id: string;
            nome: string;
            sobrenome: string;
            data_nascimento: string;
            cpf: string;
            sexo: string;
            board: any;
        };
        relationships: {
            especialidade: {
                data: {
                    type: "especialidades";
                    id: string;
                };
            };
        };
    };
}

export class SignatureAuth {
    client_id: string = "02459271000135"; //Identificação da aplicação;
    client_secret: string = "HawgomleidpochytwokowturWyfrof7"; //Senha da aplicação;
    username: string; //Identificação do usuário por meio do CPF/CNPJ. Pode ser do tipo string, preencha com zeros à esquerda (11 dígitos para CPF e 14 para CNPJ).
    password: string; //Número do OTP gerado pela aplicação.
    grant_type: string = "password"; //Fixo "Password"
    scope: string = "signature_session";
    lifetime: number = 259200; //Indica o tempo de vida desejado para o token a ser gerado em segundos. Possuindo tempo tempo máximo de 7 dias para pessoa física, e 30 dias para pessoa jurídica.
}

export class SignatureDocument {
    id: string = "0";
    signature_setting: string = "default";
    original_file_name: string = "Rel_91524.pdf";
    data: string;
}

export class SignatureSettings {
    id: string = "default";
    contact: string = "() ";
    location: string = "Bahia - BA";
    reason: string = "Assinatura_Documento";
    visible_signature: boolean = true; // (true or false desabilita a assinatura visível)
    visible_sign_page: number = 1; //( Página onde será inserido a assinatura visível. Envie "1" para a primeira página "-1" para última e "*" para todas)
    visible_sign_x: number = 0;
    visible_sign_y: number = 790;
    visible_sign_width: number = 230;
    visible_sign_height: number = 50;
    /*extraInfo: [
        {
            name: string
            value: string
        },
        {
            name: string
            value: string
        },
        {
            name: string
            value: string
        },
        {
            name: string
            value: string
        },
        {
            name: string
            value: string
        }
    ]*/
    documents: [];
}

export class Signature {
    certificate_alias: string; //
    type: string = "PDFSignature"; /*Tipo de assinatura
    - CMS-attached
    - CMS-detached
    - PDFSignature 
    - CAdEs-attached
    - CAdEs-detached
    - PAdEs
    - XAdES */
    hash_algorithm: string = "SHA256"; //Algoritmo de hash que será utilizado na assinatura (SHA1,SHA256, SHA384 ou SHA512)
    main: boolean = false;
    auto_fix_document: boolean = true; //Habilita autocorreção do documento caso disponível
    mode: string = "sync";
    signature_settings = [new SignatureSettings()];
    documents_source: string =
        "DATA_URL"; /*Origem dos Documentos: DATA_URL, FILE_PATH, UPLOAD_REFERENCE, AWS_S3, GCP_STORAGE, HASH */
    documents: SignatureDocument[];
}
